// @ts-nocheck
(function () {
  function sendWebhook(formEl) {
    var webhookUrl = formEl.dataset.webhookUrl;
    if (!webhookUrl) return;

    var payload = {
      form_id: formEl.id || null,
      page_url: window.location.href,
      submitted_at: new Date().toISOString(),
      fields: {}
    };

    var formData = new FormData(formEl);
    formData.forEach(function (value, key) {
      if (value instanceof File) return;

      var cleanKey = key;
      if (cleanKey.indexOf('contact[') === 0 && cleanKey.indexOf(']') === cleanKey.length - 1) {
        cleanKey = cleanKey.slice(8, -1);
      }

      if (payload.fields.hasOwnProperty(cleanKey)) {
        if (Array.isArray(payload.fields[cleanKey])) {
          payload.fields[cleanKey].push(value);
        } else {
          payload.fields[cleanKey] = [payload.fields[cleanKey], value];
        }
      } else {
        payload.fields[cleanKey] = value;
      }
    });

    try {
      navigator.sendBeacon(webhookUrl, new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    } catch (err) {
      // Fail silently so the Shopify submission is never blocked.
    }
  }

  async function submitToHubSpot(formEl) {
    // Try to find HubSpot credentials from the section first (consultation form)
    var sectionEl = formEl.closest('.custom-consultation-form');
    var portalId = sectionEl ? sectionEl.dataset.hubspotPortalId : null;
    var formGuid = sectionEl ? sectionEl.dataset.hubspotFormGuid : null;

    // If not found in section, try the form wrapper (accordion form)
    if (!portalId || !formGuid) {
      var formWrapper = formEl.closest('.custom-contact-form-single');
      if (formWrapper) {
        portalId = formWrapper.dataset.hubspotPortalId;
        formGuid = formWrapper.dataset.hubspotFormGuid;
      }
    }

    if (!portalId || !formGuid) {
      console.warn('HubSpot Portal ID or Form GUID is not configured.');
      return false;
    }

    // Get form data
    var formData = new FormData(formEl);
    var firstName = formData.get('contact[first_name]') || '';
    var lastName = formData.get('contact[last_name]') || '';
    var email = formData.get('contact[email]') || '';
    var phone = formData.get('contact[phone]') || '';
    var message = formData.get('contact[body]') || '';
    var privacyPolicy = formData.get('contact[privacy_policy]') || '';

    // Clean phone number format for HubSpot
    var cleanPhone = phone.replace(/[^0-9+]/g, '');

    // Convert checkbox to text for privacy policy
    var privacyPolicyValue = (privacyPolicy === 'on' || privacyPolicy === true || privacyPolicy === 'true') ? 'Yes' : '';

    var hubspotData = {
      submittedAt: Date.now(),
      fields: [
        { name: 'firstname', value: firstName },
        { name: 'lastname', value: lastName },
        { name: 'email', value: email },
        { name: 'phone', value: cleanPhone },
        { name: 'tell_us_what_youre_working_on', value: message },
        { name: 'privacy_policy', value: privacyPolicyValue }
      ],
      context: {
        pageUri: window.location.href,
        pageName: document.title
      }
    };

    try {
      var response = await fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/' + portalId + '/' + formGuid,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(hubspotData)
        }
      );

      if (!response.ok) {
        var text = await response.text();
        throw new Error('HubSpot submission failed (' + response.status + '): ' + text);
      }

      return true;
    } catch (err) {
      console.error('HubSpot submission error:', err);
      // Don't block the Shopify submission if HubSpot fails
      return false;
    }
  }

  function validateForm(formEl) {
    var valid = true;
    var fields = formEl.querySelectorAll('[required], [data-required="true"]');

    fields.forEach(function (field) {
      field.classList.remove('msf-error');

      if (field.type === 'checkbox') {
        var wrapper = field.closest('.msf-checkbox-wrapper');
        var checkboxError = wrapper ? wrapper.querySelector('.msf-checkbox-error') : null;
        var checkboxLabel = field.closest('.msf-checkbox');
        if (checkboxError) checkboxError.classList.remove('is-visible');

        if (!field.checked) {
          if (checkboxLabel) checkboxLabel.classList.add('msf-error');
          if (checkboxError) checkboxError.classList.add('is-visible');
          valid = false;
        }
      } else if (field.tagName.toLowerCase() === 'select') {
        if (!field.value || field.value === '') {
          field.classList.add('msf-error');
          valid = false;
        }
      } else if (!field.value.trim()) {
        field.classList.add('msf-error');
        valid = false;
      }
    });

    var emailInput = formEl.querySelector('input[type="email"]');
    if (emailInput && emailInput.value.trim()) {
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(emailInput.value.trim())) {
        emailInput.classList.add('msf-error');
        valid = false;
      }
    }

    return valid;
  }

  // Catch submits as early as possible so other scripts (Shopify captcha/bot protection,
  // apps, etc.) cannot override our validation.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList.contains('msf-form')) return;
    if (!form.closest('.custom-contact-form-single')) return;

    if (!validateForm(form)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  function initSingleStepForm(section) {
    var form = section.querySelector('.msf-form');

    // Disable browser's native validation to use custom validation styling
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
    }

    if (form) {
      form.addEventListener('submit', async function (e) {
        if (!validateForm(form)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return;
        }

        // Prevent default Shopify submission to avoid duplicate HubSpot forms
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var submitBtn = form.querySelector('.msf-btn-submit');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }

        try {
          // Send to HubSpot first (blocking)
          await submitToHubSpot(form);

          // Send webhook if configured (non-blocking)
          sendWebhook(form);

          // Manually submit the form to Shopify for normal processing and redirect
          form.submit();
        } catch (err) {
          console.error('Form submission error:', err);
          // Re-enable the button if there's an error
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'SUBMIT';
          }
        }
      });
    }

    var phoneInput = section.querySelector('input[name="contact[phone]"]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function (e) {
        var digits = e.target.value.replace(/\D/g, '').slice(0, 10);
        var formatted = '';
        if (digits.length > 6) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
        } else if (digits.length > 3) {
          formatted = '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
        } else if (digits.length > 0) {
          formatted = '(' + digits;
        }
        e.target.value = formatted;
      });
    }

    var fileInput = section.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.addEventListener('change', function (e) {
        var fileName = e.target.files && e.target.files[0] ? e.target.files[0].name : '';
        var nameEl = e.target.closest('.msf-file-wrap').querySelector('.msf-file-name');
        var textEl = e.target.closest('.msf-file-wrap').querySelector('.msf-file-text');
        if (nameEl) nameEl.textContent = fileName;
        if (textEl) textEl.textContent = fileName ? '' : 'Click to upload';
      });
    }

    var checkbox = section.querySelector('.msf-checkbox input[type="checkbox"]');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        var checkboxLabel = checkbox.closest('.msf-checkbox');
        var wrapper = checkbox.closest('.msf-checkbox-wrapper');
        var checkboxError = wrapper ? wrapper.querySelector('.msf-checkbox-error') : null;
        if (checkboxLabel) checkboxLabel.classList.remove('msf-error');
        if (checkboxError) checkboxError.classList.remove('is-visible');
      });
    }
  }

  function init() {
    document.querySelectorAll('.custom-contact-form-single').forEach(function (section) {
      initSingleStepForm(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
